import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import HomePage from './pages/HomePage.jsx';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HomePage />
  </React.StrictMode>
);

// react-snapでプリレンダリングされた場合はhydrate、そうでない場合はrender
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
